import React from "react";
import "./MainTitle.css";
const MainTitle = () => {
  return (
    <div class="container-main">
      {/*<div class="take-input">
     <input type="text" placeholder="Write any text" />
    <a href="javascript:void(0);">Enter Text</a>
  </div>*
      <div class="animate seven">
        <span>c</span>
        <span>s</span>
        <span>s</span>
        <span>3</span> &nbsp;
        <span>a</span>
        <span>n</span>
        <span>i</span>
        <span>m</span>
        <span>a</span>
        <span>t</span>
        <span>i</span>
        <span>o</span>
        <span>n</span>
        <span>s</span>
        <a class="repeat" href="javascript:void(0);">
          Repeat Animation
        </a>
      </div>

      <div class="animate one">
        <span>c</span>
        <span>s</span>
        <span>s</span>
        <span>3</span> &nbsp;
        <span>a</span>
        <span>n</span>
        <span>i</span>
        <span>m</span>
        <span>a</span>
        <span>t</span>
        <span>i</span>
        <span>o</span>
        <span>n</span>
        <span>s</span>
        <a class="repeat" href="javascript:void(0);">
          Repeat Animation
        </a>
      </div>

      <div class="animate two">
        <span>c</span>
        <span>s</span>
        <span>s</span>
        <span>3</span> &nbsp;
        <span>a</span>
        <span>n</span>
        <span>i</span>
        <span>m</span>
        <span>a</span>
        <span>t</span>
        <span>i</span>
        <span>o</span>
        <span>n</span>
        <span>s</span>
        <a class="repeat" href="javascript:void(0);">
          Repeat Animation
        </a>
      </div>

      <div class="animate three">
        <span>c</span>
        <span>s</span>
        <span>s</span>
        <span>3</span> &nbsp;
        <span>a</span>
        <span>n</span>
        <span>i</span>
        <span>m</span>
        <span>a</span>
        <span>t</span>
        <span>i</span>
        <span>o</span>
        <span>n</span>
        <span>s</span>
        <a class="repeat" href="javascript:void(0);">
          Repeat Animation
        </a>
      </div>

      <div class="animate four">
        <span>c</span>
        <span>s</span>
        <span>s</span>
        <span>3</span> &nbsp;
        <span>a</span>
        <span>n</span>
        <span>i</span>
        <span>m</span>
        <span>a</span>
        <span>t</span>
        <span>i</span>
        <span>o</span>
        <span>n</span>
        <span>s</span>
        <a class="repeat" href="javascript:void(0);">
          Repeat Animation
        </a>
      </div>

      <div class="animate five">
        <span>c</span>
        <span>s</span>
        <span>s</span>
        <span>3</span> &nbsp;
        <span>a</span>
        <span>n</span>
        <span>i</span>
        <span>m</span>
        <span>a</span>
        <span>t</span>
        <span>i</span>
        <span>o</span>
        <span>n</span>
        <span>s</span>
        <a class="repeat" href="javascript:void(0);">
          Repeat Animation
        </a>
      </div>*/}

      <div class="animate six">
        <h1>N</h1>
        <h1>e</h1>
        <h1>x</h1>
        <h1>t</h1> &nbsp;
        <h1>T</h1>
        <h1>e</h1>
        <h1>c</h1>
        <h1>h</h1> &nbsp;
        <h1>A</h1>
        <h1>I</h1> &nbsp;
        <h1>S</h1>
        <h1>o</h1>
        <h1>l</h1>
        <h1>u</h1>
        <h1>t</h1>
        <h1>i</h1>
        <h1>o</h1>
        <h1>n</h1>
        <h1>s</h1>
      </div>
    </div>
  );
};

export { MainTitle };
